import isEmail from "validator/lib/isEmail";
export function emailRule() {
    var asciiPrintableCharsPattern = /^[\x20-\x7E]+$/; // ASCII印字可能文字からなる文字列
    return function (input) {
        return (isEmail(input) && asciiPrintableCharsPattern.test(input)) ||
            "正しいメールアドレスを入力してください";
    };
}
//# sourceMappingURL=email.js.map